'use strict';

bbw.directive.bbwUpdateOn = ['$parse', function($parse) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var cfg = $parse(attrs.bbwUpdateOn)();
            if (!angular.isObject(cfg)) {
                return;
            }
            angular.forEach(cfg, function(key, eventName) {
                scope.$on(bbw.event[eventName], function(event, args) {
                    args && args[key] && element.text(args[key]);
                });
            });
        }
    };
}];
